<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='专业设置' url='/basicInfo/major/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.name' label='名称'></SearchNormalText>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/basicInfo/major/add" buttonname="新增"></AddButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="DictName" label="名称">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <!--begin: Pager -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
          <!--end: Pager -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluationList',
  data () {
    return {
      condition: {
        name: '',
        token: sessionStorage.getItem('token'),
        pageSize: 10,
        currentPage: 1,
        recordCount: 0
      },
      tableData: null,
      searchUrl: this.$utils.Url.system + '/systemapi/dictitem/list',
      loading: true
    }
  },
  methods: {
    // 调整每页显示数
    handleCurrentChange: function (val) {
      this.condition.currentPage = val
    },
    // 分页操作
    handleSizeChange: function (val) {
      this.condition.pageSize = val
      this.condition.currentPage = 1
    },
    Edit: function (row) {
      this.$router.push({name: 'DictEdit', params: {id: row.DictItemID, dictname: row.DictName}})
    },
    Delete: function (row) {
      console.log(row.DictItemName)
      var args = {
        id: row.DictItemID,
        token: this.condition.token
      }
      this.$utils.Delete(this.$utils.Url.system + '/systemapi/dictitem/delete', args, row.DictItemName, this.$refs.btnSearch.Search)
    }
  },
  mounted: function () {
    this.$refs.btnSearch.Search()
  }
}
</script>

<style>
</style>
